export default {
    name: 'NavBar',
    watch: {
        $route (to, from) {
            window.scrollTo(0, 0)
        }
    }
}